export default __webpack_public_path__ + "static/media/arrow-single-right.de420e94.svg";